// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2nG2M","rootSuccess":"CompleteLink_rootSuccess__3N99F","rootFailure":"CompleteLink_rootFailure__310hg","isDisabled":"CompleteLink_isDisabled__2dPv5"};